import * as styles from '@/styles/components/TextButton';

export type TextButton = {
  color?: string;
  weight?: 'normal' | 'bold';
  underline?: boolean;
  fontSize?: string;
} & JSX.IntrinsicElements['button'];

const TextButton = ({
  color = 'inherit',
  weight = 'bold',
  underline = true,
  fontSize,
  children,
  ...props
}: TextButton) => {
  return (
    <span>
      <button css={styles.root({ color, weight, underline, fontSize })} type='button' {...props}>
        {children}
      </button>
    </span>
  );
};

export default TextButton;
